<div class="card">
  <h3 class="card__title">Patches by Patch Type</h3>
  <div class="legend">
    <span><i style="background: var(--green)"></i>Installed</span>
    <span><i style="background: var(--slate)"></i>Missing</span>
  </div>
  <div class="hbars">
    <div class="hbar" *ngFor="let t of patchTypes" [class.is-active]="activePatchType === t.name">
      <div class="hbar__lbl" [title]="t.name">{{ t.name }}</div>
      <div
        class="hbar__track"
        [matTooltip]="tooltip(t)"
        matTooltipPosition="above"
        tabindex="0"
        (click)="patchTypeSelect.emit(t.name)"
        (keydown.enter)="patchTypeSelect.emit(t.name)"
      >
        <div class="hbar__fill" [style.width.%]="t.pct"></div>
        <div class="hbar__miss" *ngIf="missPct(t.pct) > 0" [style.width.%]="missPct(t.pct)"></div>
      </div>
    </div>
  </div>
  <div class="axis">
    <span></span>
    <div class="axis__ticks"><span>0%</span><span>50%</span><span>100%</span></div>
  </div>
</div>
